import userApiClient from '../../../api/user';
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from '../../../hooks/useKlydoMutation';

const useRemoveClockFromUserMutation = (
  options?: UseKlydoMutationOptions<void, void>,
) => {
  return useKlydoMutation({
    mutationKey: ['remove-clock-from-user'],
    mutationFn: () => userApiClient.removeClockFromUser(),
    ...options,
  });
};

export default useRemoveClockFromUserMutation;
